import { Component, OnInit, Inject, Input } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MessageService } from 'primeng/api';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-share-popup',
  templateUrl: './share-popup.component.html',
  styleUrls: ['./share-popup.component.scss'],
  providers: [MessageService],
})
export class SharePopupComponent implements OnInit {
  @Input() data: any;
  displayShare = false;
  shareKeys: any = [];
  shareButtons = {
    facebook: {
      icon: 'fab fa-facebook',
      share: {
        desktop: 'https://www.facebook.com/sharer/sharer.php?',
      },
      params: {
        url: 'u',
        description: 'quote',
        image: 'picture',
      },
    },
    twitter: {
      icon: 'fab fa-twitter',
      share: {
        desktop: 'https://twitter.com/intent/tweet?',
      },
      params: {
        url: 'url',
        description: 'text',
        tags: 'hashtags',
        via: 'via',
      },
    },
    pinterest: {
      icon: 'fab fa-pinterest',
      share: {
        desktop: 'https://pinterest.com/pin/create/button/?',
      },
      params: {
        url: 'url',
        title: 'text',
        description: 'description',
        image: 'media',
      },
    },
    telegram: {
      icon: 'fab fa-telegram',
      share: {
        desktop: 'https://t.me/share/url?',
      },
      params: {
        url: 'url',
        description: 'text',
      },
    },
    whatsapp: {
      icon: 'fab fa-whatsapp',
      share: {
        desktop: 'https://web.whatsapp.com/send?',
        android: 'whatsapp://send?',
        ios: 'https://api.whatsapp.com/send?',
      },
      params: {
        description: 'text',
        url: 'url',
      },
    },
    /*sms: {
      icon:'fa fa-sms',
      share: {
        desktop: 'sms:?',
        ios: 'sms:&'
      },
      params: {
        description: 'body'
      },
    },*/
    email: {
      icon: 'far fa-envelope',
      share: {
        desktop: 'mailto:?',
      },
      params: {
        title: 'subject',
        description: 'body',
        url: 'url',
      },
    },
  };
  shareButton: any;

  constructor(
    private clipboard: Clipboard,
    private messageService: MessageService,
    private _platform: Platform,
    @Inject(DOCUMENT) private _document: any,
    private meta: Meta
  ) {}

  ngOnInit(): void {
    this.shareKeys = Object.keys(this.shareButtons);
  }

  copy() {
    if (!this.data) {
      return;
    }
    this.clipboard.copy(this.data.href);
    this.messageService.add({ key: 'sharesucess', life: 500, severity: 'success', summary: 'Successfully Copied' });
  }

  share() {
    this.displayShare = true;
  }

  shareLink(type: any) {
    if (!this.data) {
      return;
    }
    //console.log(this.data);
    let sharerLink: string;
    if (this._platform.IOS && this.shareButtons[type].share.ios) {
      sharerLink = this.shareButtons[type].share.ios;
    } else if (this._platform.ANDROID && this.shareButtons[type].share.android) {
      sharerLink = this.shareButtons[type].share.android;
    } else {
      sharerLink = this.shareButtons[type].share.desktop;
    }
    this.shareButton = this.shareButtons[type];
    let finalUrl = sharerLink + this.serializeParams(this.data);
    const linkElement: HTMLLinkElement = this._document.createElement('a');
    // Make it open in a new tab/window (depends on user's browser configuration)
    linkElement.setAttribute('target', '_blank');
    // Prevent security vulnerability https://medium.com/@jitbit/target-blank-the-most-underestimated-vulnerability-ever-96e328301f4c
    linkElement.setAttribute('rel', 'noopener noreferrer');
    linkElement.href = finalUrl;
    linkElement.click();
    linkElement.remove();
  }

  serializeParams(params: any): string {
    return Object.entries(this.shareButton.params)
      .map(([key, value]) => {
        // Check if share button param has a map function
        const paramFunc: any = this.shareButton.paramsFunc ? this.shareButton.paramsFunc[key] : null;

        if (params[key] || paramFunc) {
          const paramValue = paramFunc ? paramFunc(params) : params[key];
          return `${value}=${paramValue}`;
        }
        return '';
      })
      .filter((urlParam) => urlParam !== '')
      .join('&');
  }
}
